import { REGEX } from '@/onenetwork/constants/onenetwork.regex.const'
import * as yup from 'yup'

export const schemaUpdateBroker = yup.object({
  // province_id: yup.string().required('Tỉnh/Thành phố là bắt buộc'),
  // district_id: yup.string().required('Quận/Huyện là bắt buộc'),
  // ward_id: yup.string().required('Phường/Xã là bắt buộc'),
  // certificates: yup.array().of(
  //   yup.object().shape({
  //     fileName: yup.string().required(),
  //     uuid: yup.string().required(),
  //     type: yup.string().required(),
  //     size: yup.number().required()
  //   })
  // ).nullable()
})
